import LightningLanderThemeEditor from "features/lightningLanders/components/LightningLanderThemeEditor"
import { landerDefaultTheme } from "features/lightningLanders/providers/LightningLanderThemeProvider"
import { LightningLanderThemeSettings } from "features/lightningLanders/types"
import { useCallback, useEffect, useState } from "react"
import GlassCard from "Components/GlassCard/GlassCard"
import { Box } from "@mui/material"
import SavingButton from "Components/UI/SavingButton"
import { useSave } from "Hooks/useSave"
import { saveProjectSetting } from "features/project/services/projectSettingsService"
import { useNotification, useSelectedProject } from "Hooks"
import { ApiProjectSettingKey } from "@incendium/api"
import Loading from "Components/Loading/Loading"
import { isEmpty } from "Helpers/isEmpty"

function LightningThemePage() {
    const { selectedProject, projectSettings, setProjectSettings } = useSelectedProject();
    const [theme, setTheme] = useState<LightningLanderThemeSettings | null>(null)
    const { saving, save } = useSave()
    const { showSuccessNotification, showErrorNotification } = useNotification();
    const [loaded, setLoaded] = useState(false)

    const onSave = useCallback(async () => {
        save(async () => {
            try {
                await saveProjectSetting(
                    {
                        key: ApiProjectSettingKey.LANDING_THEME,
                        value: JSON.stringify(theme),
                    },
                    selectedProject!
                );
                setProjectSettings(prev => ({
                    ...prev,
                    [ApiProjectSettingKey.LANDING_THEME]: JSON.stringify(theme)
                }))
                showSuccessNotification(`Theme Settings Saved`);
            } catch (error) {
                showErrorNotification(`Error saving Theme Settings`);
            }
        })
    }, [save, showSuccessNotification, showErrorNotification, setProjectSettings, theme])

    useEffect(() => {
        if (!selectedProject || isEmpty(projectSettings)) {
            return
        }
        if (projectSettings[ApiProjectSettingKey.LANDING_THEME]) {
            setTheme(JSON.parse(projectSettings[ApiProjectSettingKey.LANDING_THEME]) as LightningLanderThemeSettings)
        } else {
            setTheme(landerDefaultTheme)
        }
        setLoaded(true)
    }, [projectSettings, setTheme])

    if (!loaded || !theme) {
        return <Loading fullHeight />
    }


    return (
        <Box display="flex" justifyContent="flex-start">
            < GlassCard boxProps={{ p: 2, width: 500 }
            } >
                <LightningLanderThemeEditor theme={theme} setTheme={setTheme} />
                <SavingButton
                    saving={saving}
                    onSave={onSave}
                >
                    Save
                </SavingButton>
            </GlassCard >
        </Box >
    )
}

export default LightningThemePage